module.exports = __webpack_public_path__ + "006.fb8f8897.png";